import { useMemo, useState, useCallback } from 'react'
import * as actions from '$actions/realtime'
import cn from 'clsx'
import {
    NOTIFICATION_TARGETS,
    NOTIFICATION_TARGET_USER,
    NOTIFICATION_TARGET_ORGANIZATION,
} from '@constants/realtime'
import { getFormValuesObject } from '@utils'

const SendDemoNotificationForm = ({
    className,
}) => {
    
    const [target, setTarget] = useState(NOTIFICATION_TARGET_ORGANIZATION)
    
    const recipientPlaceholder = useMemo(() => (
        target === NOTIFICATION_TARGET_ORGANIZATION
            ? 'Organization ID'
            : 'recipient@parseai.co'
    ), [target])
    
    const handleSubmit = useCallback(async e => {
        
        e.preventDefault()
        
        const values = getFormValuesObject(e)
        
        console.log('values', values)
        
        switch (target) {
            case NOTIFICATION_TARGET_USER:
                await actions.sendRealtimeNotificationUserEmail(values.recipient, values.message)
                break
            case NOTIFICATION_TARGET_ORGANIZATION:
                await actions.sendRealtimeNotificationOrg(values.recipient, values.message)
                break
            default:
                throw new Error(`Invalid target "${target}"`)
        }
        
    }, [target])
    
    return (
        
        <form
            className={cn('SendDemoNotificationForm', className)}
            onSubmit={handleSubmit}>
            
            <div className="form-control">
                <label htmlFor="demoNotificationForm-target">
                    Target
                </label>
                <select
                    id="demoNotificationForm-target"
                    className="select select-bordered"
                    name="target"
                    value={target}
                    onChange={e => setTarget(e.target.value)}>
                    {NOTIFICATION_TARGETS.map(it => (
                        <option key={`target-${it}`} value={it}>{it}</option>
                    ))}
                </select>
            </div>
            
            <div className="form-control">
                <label htmlFor="demoNotificationForm-recipient">
                    Recipient
                </label>
                <input
                    id="demoNotificationForm-recipient"
                    className="input input-bordered"
                    type="text"
                    name="recipient"
                    placeholder={recipientPlaceholder} />
            </div>
            
            <div className="form-control">
                <label htmlFor="demoNotificationForm-message">
                    Message
                </label>
                <input
                    id="demoNotificationForm-message"
                    className="input input-bordered"
                    type="text"
                    name="message"
                    placeholder="Message" />
            </div>
            
            <div className="form-control">
                <label htmlFor="demoNotificationForm-type">Type</label>
                <select
                    className="select select-bordered"
                    id="demoNotificationForm-type"
                    name="type">
                    <option value="MessagePlainEvent">MessagePlainEvent</option>
                </select>
            </div>
            
            <div className="form-control mt-4">
                <input
                    className="btn btn-primary"
                    type="submit"
                    value="Send Notification" />
            </div>
        
        </form>
        
    )
    
}

export default SendDemoNotificationForm
